export const useSearchRoute = () => {
  interface Query {
    q: string;
    lat?: number;
    lng?: number;
    facets?: string[];
  }

  const route = useRoute();
  const section = route.params.section as string;

  const getQuery = (q: string, geoloc: AlgoliaGeoloc, facets: string[]) => {
    const query: Query = {
      q,
    };

    if (
      geoloc &&
      geoloc.lat != null &&
      geoloc.lng != null &&
      !isNaN(geoloc.lat) &&
      !isNaN(geoloc.lng)
    ) {
      query.lat = geoloc.lat;
      query.lng = geoloc.lng;
    }
    if (facets.length) {
      query.facets = facets;
    }
    return query;
  };

  const updateRoute = (q: string, geoloc: AlgoliaGeoloc, facets: string[]) => {
    const query = getQuery(q, geoloc, facets);
    navigateTo({
      path: `/${section}/recherche`,
      query: {
        ...query,
      },
    });
  };

  return {
    updateRoute,
    getQuery,
  };
};
